export default __webpack_public_path__ + "img/406d44e2822f4851f55ec05eec60c35a.svg";